import React, { useEffect, useState } from 'react';
import {
  Image,
  Video,
  FileText
} from 'lucide-react';

const FlowAnimation = () => {
  const [activeConnections, setActiveConnections] = useState([]);

  const platforms = [
    {
      name: 'Instagram',
      logo: (
        <svg viewBox="0 0 24 24" className="w-10 h-10 md:w-12 md:h-12" fill="white">
          <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
        </svg>
      ),
      color: 'from-pink-500 to-purple-600',
      position: { x: -200, y: -150 }
    },
    {
      name: 'Facebook',
      logo: (
        <svg viewBox="0 0 24 24" className="w-10 h-10 md:w-12 md:h-12" fill="white">
          <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
        </svg>
      ),
      color: 'from-blue-500 to-blue-700',
      position: { x: 200, y: -150 }
    },
    {
      name: 'X (Twitter)',
      logo: (
        <svg viewBox="0 0 24 24" className="w-10 h-10 md:w-12 md:h-12" fill="white">
          <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
        </svg>
      ),
      color: 'from-gray-800 to-black',
      position: { x: -280, y: 0 }
    },
    {
      name: 'LinkedIn',
      logo: (
        <svg viewBox="0 0 24 24" className="w-10 h-10 md:w-12 md:h-12" fill="white">
          <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
        </svg>
      ),
      color: 'from-blue-600 to-blue-800',
      position: { x: 280, y: 0 }
    },
    {
      name: 'YouTube',
      logo: (
        <svg viewBox="0 0 24 24" className="w-10 h-10 md:w-12 md:h-12" fill="white">
          <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
        </svg>
      ),
      color: 'from-red-500 to-red-700',
      position: { x: -200, y: 150 }
    },
    {
      name: 'TikTok',
      logo: (
        <svg viewBox="0 0 24 24" className="w-10 h-10 md:w-12 md:h-12" fill="white">
          <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z"/>
        </svg>
      ),
      color: 'from-gray-800 to-black',
      position: { x: 200, y: 150 }
    }
  ];

  useEffect(() => {
    // Başlangıçta tüm platformları aktif et
    setActiveConnections([0, 1, 2, 3, 4, 5]);

    // Sonra sırayla animasyon yap
    const animateSequentially = () => {
      setActiveConnections([]);
      platforms.forEach((_, index) => {
        setTimeout(() => {
          setActiveConnections(prev => [...prev, index]);
        }, (index + 1) * 400);
      });
    };

    // İlk animasyonu başlat
    setTimeout(animateSequentially, 500);

    // Her 6 saniyede tekrarla
    const interval = setInterval(animateSequentially, 6000);

    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Çizgi çizmek için yardımcı fonksiyon
  const getLineStyle = (pos, isActive) => {
    const length = Math.sqrt(pos.x * pos.x + pos.y * pos.y);
    const angle = Math.atan2(pos.y, pos.x) * (180 / Math.PI);

    return {
      width: `${length}px`,
      height: '3px',
      transform: `rotate(${angle}deg)`,
      transformOrigin: '0 50%',
      position: 'absolute',
      left: '50%',
      top: '50%',
      zIndex: 5,
      background: 'linear-gradient(90deg, rgba(59, 130, 246, 0.8) 0%, rgba(168, 85, 247, 0.8) 100%)',
      backgroundSize: '20px 3px',
      backgroundImage: isActive
        ? 'repeating-linear-gradient(90deg, rgba(59, 130, 246, 0.8) 0px, rgba(168, 85, 247, 0.8) 8px, transparent 8px, transparent 16px)'
        : 'none',
      animation: isActive ? 'lineFlow 0.25s linear infinite' : 'none'
    };
  };

  return (
    <div className="relative w-full h-[500px] md:h-[600px] flex items-center justify-center">
      {/* Connection Lines using CSS */}
      {platforms.map((platform, index) => {
        const isActive = activeConnections.includes(index);
        return (
          <div
            key={`line-${index}`}
            className={`transition-all duration-1000 ${isActive ? 'opacity-100' : 'opacity-0'}`}
            style={getLineStyle(platform.position, isActive)}
          />
        );
      })}

      {/* Central Content Hub */}
      <div className="relative z-20">
        <div className="w-32 h-32 md:w-40 md:h-40 bg-gradient-to-br from-blue-600 via-purple-600 to-pink-600 rounded-full shadow-2xl flex items-center justify-center transform hover:scale-110 transition-transform duration-300">
          <div className="text-center text-white">
            <img
              src="/logo.svg"
              alt="Social Octo"
              className="w-16 h-16 md:w-20 md:h-20 mx-auto animate-pulse"
            />
          </div>
        </div>

        {/* Pulsing rings */}
        <div className="absolute inset-0 rounded-full bg-blue-400 opacity-20 animate-ping"></div>
        <div className="absolute inset-0 rounded-full bg-purple-400 opacity-20 animate-ping" style={{ animationDelay: '0.5s' }}></div>
      </div>

      {/* Platform Icons */}
      {platforms.map((platform, index) => {
        const isActive = activeConnections.includes(index);
        const pos = platform.position;

        return (
          <React.Fragment key={index}>
            {/* Data Particles */}
            {isActive && (
              <>
                {[0, 1, 2].map((particleIndex) => (
                  <div
                    key={`particle-${index}-${particleIndex}`}
                    className="absolute left-1/2 top-1/2 w-3 h-3 bg-gradient-to-r from-blue-400 to-purple-500 rounded-full"
                    style={{
                      zIndex: 10,
                      animation: `flow-${index} 2s ease-in-out infinite`,
                      animationDelay: `${particleIndex * 0.6}s`,
                      transform: 'translate(-50%, -50%)',
                    }}
                  />
                ))}
              </>
            )}

            {/* Platform Card */}
            <div
              className={`absolute transform -translate-x-1/2 -translate-y-1/2 transition-all duration-700 ${
                isActive ? 'scale-100 opacity-100' : 'scale-50 opacity-0'
              }`}
              style={{
                left: `calc(50% + ${pos.x}px)`,
                top: `calc(50% + ${pos.y}px)`,
                zIndex: 15
              }}
            >
              <div className={`w-20 h-20 md:w-24 md:h-24 bg-gradient-to-br ${platform.color} rounded-full shadow-xl flex items-center justify-center transform hover:scale-110 hover:rotate-6 transition-all duration-300 cursor-pointer`}>
                {platform.logo}
              </div>
              <p className="text-center mt-2 text-xs md:text-sm font-semibold text-gray-700">
                {platform.name}
              </p>
            </div>
          </React.Fragment>
        );
      })}

      {/* Floating Content Icons */}
      <div className="absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2" style={{ zIndex: 1 }}>
        <Image className="absolute w-8 h-8 text-blue-400 opacity-20 animate-float" style={{ left: '-100px', top: '-80px', animationDelay: '0s' }} />
        <Video className="absolute w-8 h-8 text-purple-400 opacity-20 animate-float" style={{ right: '-100px', top: '-60px', animationDelay: '1s' }} />
        <FileText className="absolute w-8 h-8 text-pink-400 opacity-20 animate-float" style={{ left: '-90px', bottom: '-70px', animationDelay: '2s' }} />
      </div>

      {/* Animation Keyframes */}
      <style jsx>{`
        @keyframes lineFlow {
          0% {
            background-position: 0 0;
          }
          100% {
            background-position: 20px 0;
          }
        }

        @keyframes flow-0 {
          0%, 100% {
            transform: translate(-50%, -50%) translate(0, 0);
            opacity: 0;
          }
          10% {
            opacity: 1;
          }
          50% {
            transform: translate(-50%, -50%) translate(-200px, -150px);
            opacity: 1;
          }
          60%, 100% {
            transform: translate(-50%, -50%) translate(-200px, -150px);
            opacity: 0;
          }
        }

        @keyframes flow-1 {
          0%, 100% {
            transform: translate(-50%, -50%) translate(0, 0);
            opacity: 0;
          }
          10% {
            opacity: 1;
          }
          50% {
            transform: translate(-50%, -50%) translate(200px, -150px);
            opacity: 1;
          }
          60%, 100% {
            transform: translate(-50%, -50%) translate(200px, -150px);
            opacity: 0;
          }
        }

        @keyframes flow-2 {
          0%, 100% {
            transform: translate(-50%, -50%) translate(0, 0);
            opacity: 0;
          }
          10% {
            opacity: 1;
          }
          50% {
            transform: translate(-50%, -50%) translate(-280px, 0);
            opacity: 1;
          }
          60%, 100% {
            transform: translate(-50%, -50%) translate(-280px, 0);
            opacity: 0;
          }
        }

        @keyframes flow-3 {
          0%, 100% {
            transform: translate(-50%, -50%) translate(0, 0);
            opacity: 0;
          }
          10% {
            opacity: 1;
          }
          50% {
            transform: translate(-50%, -50%) translate(280px, 0);
            opacity: 1;
          }
          60%, 100% {
            transform: translate(-50%, -50%) translate(280px, 0);
            opacity: 0;
          }
        }

        @keyframes flow-4 {
          0%, 100% {
            transform: translate(-50%, -50%) translate(0, 0);
            opacity: 0;
          }
          10% {
            opacity: 1;
          }
          50% {
            transform: translate(-50%, -50%) translate(-200px, 150px);
            opacity: 1;
          }
          60%, 100% {
            transform: translate(-50%, -50%) translate(-200px, 150px);
            opacity: 0;
          }
        }

        @keyframes flow-5 {
          0%, 100% {
            transform: translate(-50%, -50%) translate(0, 0);
            opacity: 0;
          }
          10% {
            opacity: 1;
          }
          50% {
            transform: translate(-50%, -50%) translate(200px, 150px);
            opacity: 1;
          }
          60%, 100% {
            transform: translate(-50%, -50%) translate(200px, 150px);
            opacity: 0;
          }
        }

        @keyframes float {
          0%, 100% {
            transform: translateY(0) rotate(0deg);
          }
          50% {
            transform: translateY(-20px) rotate(10deg);
          }
        }

        .animate-float {
          animation: float 3s ease-in-out infinite;
        }
      `}</style>
    </div>
  );
};

export default FlowAnimation;
